import { render, staticRenderFns } from "./ReviewOrderUpdateTxT.vue?vue&type=template&id=0d213d02"
import script from "./ReviewOrderUpdateTxT.vue?vue&type=script&lang=js"
export * from "./ReviewOrderUpdateTxT.vue?vue&type=script&lang=js"
import style0 from "./ReviewOrderUpdateTxT.vue?vue&type=style&index=0&id=0d213d02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports